import { render, staticRenderFns } from "./Test1.vue?vue&type=template&id=5c70a28c"
import script from "./Test1.vue?vue&type=script&lang=js"
export * from "./Test1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports